import React, { useEffect, useState } from 'react';
import { Form } from 'src/core/forms';
import { useDispatch } from 'react-redux';
import { CustomizationSkeleton } from 'src/elements/Skeletons/Skeletons';

import { paths } from '../../../config';
import { Actions } from '../../Forms/Actions';
import { ButtonLink } from '../../Button/ButtonLink';
import { InfoBlock } from '../InfoBlock';
import { useCustomisation } from '../hooks/useCustomisation';
import { ApplicationType, Step } from '../feature/customisation.types';
import { CustomisationMsg } from '../feature/customisation.actions';
import { TypeFieldset } from '../steps/TypeFieldSet';

import classes from './Pages.scss';

interface Props {
    initialValues: { applicationType: string };
}

export const Type: React.FC<Props> = ({ initialValues }) => {
    const dispatch = useDispatch();

    const [applicationTypeName, setApplicationTypeName] = useState(initialValues.applicationType);

    const submitType = (values) => {
        const type = values.applicationType === 'logo' ? ApplicationType.Logo : ApplicationType.Text;
        dispatch(CustomisationMsg('Customisation.TypeSubmit', type));
    };

    const onApplicationTypeChange = (values) => {
        setApplicationTypeName(values.applicationType);
    };

    return (
        <div className={classes.fadein}>
            <h2 className={classes.header}>4. Choose application type</h2>
            <Form
                className={classes.form}
                onSubmit={submitType}
                initialValues={initialValues}
                onValueChange={onApplicationTypeChange}
            >
                <TypeFieldset />
                <div className={classes.applicationMethodAction}>
                    <Actions primaryText="Continue" direction="reverse" variant="space-between">
                        <ButtonLink variant="light" to={paths.customisation.artwork}>
                            Back a step
                        </ButtonLink>
                    </Actions>
                    <div className={classes.applicationMethodSelected}>
                        <span>{applicationTypeName} </span>selected
                    </div>
                </div>
            </Form>
            <InfoBlock />
        </div>
    );
};

export const PageTypeConnected: React.FC = () => {
    const {
        loadStep,
        isPending,
        state: { application_type },
    } = useCustomisation();

    useEffect(() => {
        setTimeout(() => {
            loadStep({ step: Step.ApplicationType });
        });
    }, [loadStep]);

    if (isPending) return <CustomizationSkeleton />;

    return <Type initialValues={{ applicationType: application_type.toLowerCase() }} />;
};
